function isIframe(): boolean {
  return window.top !== window.self;
}

export default isIframe;
